import { render, staticRenderFns } from "./Meny.vue?vue&type=template&id=6ab88fd9&scoped=true&"
import script from "./Meny.vue?vue&type=script&lang=js&"
export * from "./Meny.vue?vue&type=script&lang=js&"
import style0 from "./Meny.vue?vue&type=style&index=0&id=6ab88fd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab88fd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/atlassian/pipelines/agent/build/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VSelect})
